import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";

function money(v) {
  if (v >= 1000) return `$${(v / 1000).toFixed(1)}k`;
  return `$${Math.round(v)}`;
}

export default function CategoriesChart({ items }) {
  const rows = (items || []).slice().sort((a, b) => b.revenue - a.revenue);
  const total = rows.reduce((s, r) => s + (r.revenue || 0), 0);
  // Ranking-driven fill: darker for top categories
  const withShare = rows.map((r, i) => ({
    ...r,
    share_pct: total ? (r.revenue / total) * 100 : 0,
    rank: i,
  }));

  const height = Math.max(220, withShare.length * 34 + 40);

  return (
    <div className="border border-[#0a0a0a] bg-[#ede8dc] p-6" data-testid="categories-panel">
      <div className="flex items-baseline justify-between mb-4 flex-wrap gap-3">
        <div>
          <div className="bm-eyebrow mb-1 text-neutral-500">Table 3 &middot; Category mix</div>
          <h3 className="text-lg font-semibold">Categories</h3>
        </div>
        <div className="bm-eyebrow text-neutral-500">
          Dollar sales &middot; net of tax
          {total > 0 && <> &middot; total <span className="text-[#0a0a0a] font-mono-bm">${Math.round(total).toLocaleString()}</span></>}
        </div>
      </div>

      {withShare.length === 0 ? (
        <div className="text-sm text-neutral-500">No category data yet — kick off a sync.</div>
      ) : (
        <ResponsiveContainer width="100%" height={height}>
          <BarChart
            data={withShare}
            layout="vertical"
            margin={{ top: 4, right: 80, left: 0, bottom: 4 }}
            barCategoryGap={6}
          >
            <CartesianGrid horizontal={false} strokeDasharray="2 4" stroke="#0a0a0a20" />
            <XAxis
              type="number"
              tickFormatter={money}
              stroke="#0a0a0a"
              tick={{ fontSize: 11, fontFamily: "JetBrains Mono" }}
            />
            <YAxis
              type="category"
              dataKey="category"
              width={140}
              stroke="#0a0a0a"
              tick={{ fontSize: 11, fontFamily: "JetBrains Mono" }}
              interval={0}
            />
            <Tooltip
              contentStyle={{
                background: "#f5f2eb", border: "1px solid #0a0a0a",
                color: "#0a0a0a", fontSize: 12, fontFamily: "JetBrains Mono",
              }}
              cursor={{ fill: "#0a0a0a08" }}
              formatter={(_v, _n, entry) => {
                const r = entry?.payload || {};
                return [
                  `$${Math.round(r.revenue).toLocaleString()} · ${r.units.toLocaleString()} units · ${r.share_pct.toFixed(1)}%`,
                  r.category,
                ];
              }}
              labelFormatter={() => ""}
            />
            <Bar
              dataKey="revenue"
              fill="#0a0a0a"
              radius={[0, 0, 0, 0]}
              label={{
                position: "right",
                fontFamily: "JetBrains Mono",
                fontSize: 11,
                fill: "#0a0a0a",
                formatter: (v) => money(v),
              }}
            >
              {withShare.map((r, i) => {
                // Fade fill for lower-ranked categories
                const alpha = Math.max(0.4, 1 - i * 0.055).toFixed(2);
                return <Cell key={r.category} fill={`rgba(10,10,10,${alpha})`} />;
              })}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
